const state = {
  collapse: sessionStorage.getItem("collapse") || true
}

const mutations = {
  SET_COLLAPSE: (state) => {
    state.collapse = !state.collapse
    console.log(111, state.collapse)
    sessionStorage.setItem('collapse', state.collapse)
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js